const normalizeBaseUrl = (baseUrl?: string): string | undefined => {
  const normalized = baseUrl?.trim();
  if (!normalized) {
    return undefined;
  }

  return normalized.endsWith('/') ? normalized : `${normalized}/`;
};

export const baseFrontendUrl = (
  baseUrl: string | undefined = import.meta.env.VITE_FRONTEND_URL
): string | undefined => {
  return normalizeBaseUrl(baseUrl)?.replace(/\/$/, '');
};

export const buildFrontendUrl = (
  pathname: string,
  searchParams?: Record<string, string | undefined>,
  baseUrl: string | undefined = import.meta.env.VITE_FRONTEND_URL
): string => {
  const normalizedBaseUrl = normalizeBaseUrl(baseUrl);
  if (!normalizedBaseUrl) {
    return pathname;
  }

  const url = new URL(pathname, normalizedBaseUrl);

  if (searchParams) {
    for (const [key, value] of Object.entries(searchParams)) {
      if (typeof value === 'string' && value.trim()) {
        url.searchParams.set(key, value);
      }
    }
  }

  return url.toString();
};
